import { Outlet } from "react-router-dom";
import AppShell from "../../../design-system/navigation/app-shell/AppShell.jsx";

// Este layout será usado por rotas que precisam do AppShell
// A lógica de role e activeTab será gerenciada pelas páginas específicas
export default function DashboardLayout() {
  // Por enquanto, retornamos um placeholder
  // As páginas específicas (DashboardFamilyPage, etc.) vão renderizar o AppShell
  return <Outlet />;
}